import React, { useState, useEffect, useMemo } from 'react';
import {object, func, bool, string} from 'prop-types';

import {CloneObject, CompareDates} from '../../../utils/helpers';
import {getDateNow} from '../../../utils/convert';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {isEmptyString, isValidNumber} from '../../../utils/validator';
import {useFormErrors} from '../../hooks/useFormErrors';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {DatePickerCustom, InputPercent, InputLista, InputEntidad, InputPersona} from '../../common';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormError, FormLabel} from "../../common";

const VinculoComercioModal = (props) => {

    const entityInit = {
        id: 0,
        idComercio: 0,
        idTipoVinculoComercio: 0,
        idPersona: 0,
        idTipoPersona: 0,
        idTipoDocumento: 0,
        numeroDocumento: "",
        nombrePersona: "",
        idTipoInstrumento: 0,
        fechaInstrumentoDesde: null,
        fechaInstrumentoHasta: null,
        porcentajeCondominio: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });
    const [persona, setPersona] = useState({
        idTipoPersona: 0,
        idTipoDocumento: 0,
        numeroDocumento: "",
        nombrePersona: ""
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity}
        });
        setPersona({
            idTipoPersona: props.data.entity.idTipoPersona,
            idTipoDocumento: props.data.entity.idTipoDocumento,
            numeroDocumento: props.data.entity.numeroDocumento,
            nombrePersona: props.data.entity.nombrePersona
        });
        formSet({
            idTipoVinculoComercio: props.data.entity.idTipoVinculoComercio,
            idPersona: props.data.entity.idPersona,
            idTipoInstrumento: props.data.entity.idTipoInstrumento,
            fechaInstrumentoDesde: props.data.entity.fechaInstrumentoDesde,
            fechaInstrumentoHasta: props.data.entity.fechaInstrumentoHasta,
            porcentajeCondominio: props.data.entity.porcentajeCondominio
        });
    }
    useEffect(mount, [props.data.entity]);


    const [formValues, formHandle, , formSet] = useForm({
        idTipoVinculoComercio: 0,
        idPersona: 0,
        idTipoInstrumento: 0,
        fechaInstrumentoDesde: null,
        fechaInstrumentoHasta: null,
        porcentajeCondominio: 0
    });

    const today = useMemo(() => getDateNow(), []);

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTipoVinculoComercio = parseInt(formValues.idTipoVinculoComercio);
        row.idPersona = parseInt(formValues.idPersona);
        row.idTipoPersona = persona.idTipoPersona;
        row.idTipoDocumento = persona.idTipoDocumento;
        row.numeroDocumento = persona.numeroDocumento;
        row.nombrePersona = persona.nombrePersona;
        row.idTipoInstrumento = !isEmptyString(formValues.idTipoInstrumento) ? parseInt(formValues.idTipoInstrumento) : 0;
        row.fechaInstrumentoDesde = formValues.fechaInstrumentoDesde;
        row.fechaInstrumentoHasta = formValues.fechaInstrumentoHasta;
        row.porcentajeCondominio = formValues.porcentajeCondominio;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoVinculoComercio <= 0) errors.idTipoVinculoComercio = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idPersona <= 0) errors.idPersona = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (!isValidNumber(formValues.porcentajeCondominio, false)) errors.porcentajeCondominio = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.fechaInstrumentoDesde != null &&
            CompareDates(formValues.fechaInstrumentoDesde, today) > 0) errors.fechaInstrumentoDesde = 'No puede ser posterior a hoy';
        if (formValues.fechaInstrumentoDesde != null && formValues.fechaInstrumentoHasta != null &&
            CompareDates(formValues.fechaInstrumentoHasta, formValues.fechaInstrumentoDesde) < 0) errors.fechaInstrumentoHasta = 'No puede ser anterior a la presentación';

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Persona del comercio: ${(state.entity.id > 0) ? state.entity.nombrePersona : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.VINCULO_COMERCIO_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Detalles del vínculo" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-3">
                                                <FormLabel htmlFor="idTipoVinculoComercio" required>Tipo</FormLabel>
                                                <InputLista
                                                    name="idTipoVinculoComercio"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoVinculoComercio') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoVinculoComercio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoVinculoComercio"
                                                />
                                                <FormError message={errorOf('idTipoVinculoComercio')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-9">
                                                <FormLabel htmlFor="idPersona" required>Persona</FormLabel>
                                                <InputPersona
                                                    name="idPersona"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idPersona') ? 'is-invalid' : ''}`}
                                                    value={formValues.idPersona}
                                                    idTipoPersona={0}
                                                    onChange={(event) => {
                                                        const {target} = event;
                                                        const persona = (target.row) ? {
                                                            idTipoPersona: target.row.idTipoPersona,
                                                            idTipoDocumento: target.row.idTipoDocumento,
                                                            numeroDocumento: target.row.numeroDocumento,
                                                            nombrePersona: target.row.nombrePersona
                                                        } : {
                                                            idTipoPersona: 0,
                                                            idTipoDocumento: 0,
                                                            numeroDocumento: "",
                                                            nombrePersona: ""
                                                        };
                                                        setPersona(persona);
                                                        formHandle(event);
                                                    }}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('idPersona')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="idTipoInstrumento" className="form-label">Tipo
                                                    instrumento</label>
                                                <InputEntidad
                                                    name="idTipoInstrumento"
                                                    placeholder=""
                                                    tipName={TIPS.NAME.MODALS.TIPO_INSTRUMENTO_MODAL}
                                                    className="form-control"
                                                    value={formValues.idTipoInstrumento}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Tipo de instrumento"
                                                    entidad="TipoInstrumento"
                                                    onFormat={(row) => (row) ? row.nombre : ''}
                                                    columns={[
                                                        {Header: 'Nombre', accessor: 'nombre', width: '95%'}
                                                    ]}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaInstrumentoDesde"
                                                       className="form-label">Presentación</label>
                                                <DatePickerCustom
                                                    name="fechaInstrumentoDesde"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaInstrumentoDesde') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaInstrumentoDesde}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    maxValue={today}
                                                />
                                                <FormError message={errorOf('fechaInstrumentoDesde')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="fechaInstrumentoHasta" className="form-label">Vigencia
                                                    hasta</label>
                                                <DatePickerCustom
                                                    name="fechaInstrumentoHasta"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaInstrumentoHasta') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaInstrumentoHasta}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    minValue={formValues.fechaInstrumentoDesde}
                                                />
                                                <FormError message={errorOf('fechaInstrumentoHasta')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <FormLabel htmlFor="porcentajeCondominio" required>Condominio</FormLabel>
                                                <InputPercent
                                                    name="porcentajeCondominio"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('porcentajeCondominio') ? 'is-invalid' : ''}`}
                                                    value={formValues.porcentajeCondominio}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('porcentajeCondominio')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de vínculo comercio"
                                            processKey={props.processKey}
                                            entidad="VinculoComercio"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

VinculoComercioModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

VinculoComercioModal.defaultProps = {
    disabled: false
};

export default VinculoComercioModal;